var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "conteudo-modal" }, [
      _c("div", { attrs: { id: "app-bpmn" } }, [
        _c("div", { attrs: { id: "bpmn-container" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "informacao" }, [
        _c("div", { staticClass: "passou box" }, [
          _c("p", { staticClass: "texto-white" }, [
            _vm._v("Setor pelo qual o processo já passou")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pendente box" }, [
          _c("p", { staticClass: "texto-black" }, [
            _vm._v("Setor pelo qual o processo ainda não passou")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "atual box" }, [
          _c("p", { staticClass: "texto-white" }, [_vm._v("Setor atual")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c417162", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c417162","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppBpmnViewer.vue
// module id = null
// module chunks = 